import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();

  const handlePage = row => {
    history.push({
      pathname: '/definicion/puesto',
      state: {
        jobTitle: row.id,
        department: row.departmentId,
        isComingFrom: '/definicion/seleccion/puesto',
      },
    });
  };

  return { handlePage };
};

export default useRoute;
